import { useForm } from 'react-hook-form';
import {
  channelBuyQuery,
  mobileBrandQuery,
} from '../../../../services/react-query/optionMasterQuery';
import { useGetRegInfoEdit } from './useGetRegInfoEdit';
import { useEffect, useState, useCallback } from 'react';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { navigateTo } from '../../../../utils/navigation';
import { useGetBarcode } from './useGetBarcode';
import { useModal } from '../../../../components/modal/hooks/useModal';
import { useGetWarrantyCode } from '../../registration-add/hooks/useGetWarrantyCode';
import { useUpdateRegEdit } from './useUpdateRegEdit';
export const useGetRegEditList = () => {
  const { control, getValues, setValue, reset, handleSubmit } = useForm();
  const [state, setState] = useState();
  const [dataExp, setDataExp] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const warrantyCode = queryParams.get('code');
  const {
    mutate: onGetWarrantyCode,
    loading: isCallingWarrantyCode,
    dataSource: dataSourceWarrantyCode,
  } = useGetWarrantyCode();
  const { open: openExpModal, onToggle: onToggleExpModal } = useModal();
  const { mutate: onEditDataReg, loading: loadingEditDataReg } = useUpdateRegEdit(dataSourceWarrantyCode);
  const { mutate: onCallBarcode, loading: loadingBarcode } = useGetBarcode({ getValues, reset });
  const { data: mobileBrandList } = mobileBrandQuery();
  const { data: channelBuyList } = channelBuyQuery();

  const { loading: LoadingWarrantyEdit, dataSource } = useGetRegInfoEdit({
    warrantyCode: state?.warrantyCode,
    reset,
    setValue,
    getValues,
  });

  const onEnterBarcodeFunction = (value) => {
    onCallBarcode(value);
  };
  
  const onEnterWarrantyCode = useCallback(
    (warrantyCode) => {
      const barcode = getValues('barcodeShortcut');
      onGetWarrantyCode({ warrantyCode, barcode });
    },
    [getValues, onGetWarrantyCode],
  );

  const onSubmit = (value) => {
    onEditDataReg(value);
  };

  const goBack = () => {
    navigateTo({
      pathname: ROUTES_PATH.ROUTE_REGISTRATION_LIST.PATH,
      state: getValues(),
    });
  };

  useEffect(() => {
    setState({ warrantyCode });
  }, [warrantyCode]);

  useEffect(() => {
    const warrantyData = dataSource?.warranty;
    setDataExp(warrantyData);
  }, [dataSource]);

  return {
    control,
    getValues,
    setValue,
    mobileBrandList,
    channelBuyList,
    LoadingWarrantyEdit,
    reset,
    goBack,
    onEnterBarcodeFunction,
    onEnterWarrantyCode,
    loadingBarcode,
    openExpModal,
    onToggleExpModal,
    dataExp,
    handleSubmit,
    onSubmit,
    loadingEditDataReg,
  };
};
